import { render, staticRenderFns } from "./descuentosArticulo.vue?vue&type=template&id=68446107&scoped=true&"
import script from "./descuentosArticulo.vue?vue&type=script&lang=js&"
export * from "./descuentosArticulo.vue?vue&type=script&lang=js&"
import style0 from "./descuentosArticulo.vue?vue&type=style&index=0&id=68446107&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68446107",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/ALIO/APP/APPVentas/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VListTile } from 'vuetify/lib'
import { VSubheader } from 'vuetify/lib'
installComponents(component, {VContainer,VFlex,VLayout,VList,VListTile,VSubheader})
